import leaveByUrl from '~/namespaces/leave_by_url';
import initGroupDetails from '../shared/group_details';

leaveByUrl('group');
initGroupDetails();
